import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GridModule, FormModule } from '@coreui/angular';

@Component({
  standalone: true,
  imports: [GridModule, FormModule],
  selector: 'app-page500',
  templateUrl: './page500.component.html',
  styleUrls: ['./page500.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Page500Component {
  constructor() {}
}
